import { useEffect } from 'react';

import { CHANNEL_STATUS, IChannel } from '@/entities/channel';

import { STEP, TChannelStep } from './useChannelSteps';

type UseChannelDialogsSyncProps = {
  channelIdFromUrl?: string;
  foundChannelByIdFromUrl?: IChannel;
  step: TChannelStep;
  setOpenPendingChannelDialog: (open: boolean) => void;
  clearQueryParams: () => void;
  openAuthorizationDialogByProtocol: (channel: IChannel) => void;
};

/**
 * Хук для синхронизации диалогов с URL параметрами и состоянием канала
 * управляет открытием/закрытием диалогов на основе channelId в URL
 */
export function useChannelDialogsSyncWithChannelIdFromUrl({
  channelIdFromUrl,
  foundChannelByIdFromUrl,
  step,
  setOpenPendingChannelDialog,
  clearQueryParams,
  openAuthorizationDialogByProtocol,
}: UseChannelDialogsSyncProps) {
  // Диалог предупреждение открывается при наличии channelId в url и закрывается при отсутствии
  useEffect(() => {
    if (channelIdFromUrl) {
      setOpenPendingChannelDialog(true);
    } else {
      setOpenPendingChannelDialog(false);
    }
  }, [channelIdFromUrl, setOpenPendingChannelDialog]);

  // Очищаются query параметры если канал в статусе ready (не нужны диалоги авторизации, если канал уже авторизован после продления подписки)
  useEffect(() => {
    if (
      foundChannelByIdFromUrl?.status &&
      foundChannelByIdFromUrl?.status === CHANNEL_STATUS.READY
    ) {
      clearQueryParams();
    }
  }, [foundChannelByIdFromUrl?.status, clearQueryParams]);

  // Автоматическое открытие соответствующего окна авторизации после оплаты подписки
  useEffect(() => {
    if (
      foundChannelByIdFromUrl &&
      foundChannelByIdFromUrl?.status !== CHANNEL_STATUS.READY &&
      step !== STEP.SELECT_COMPANY
    ) {
      openAuthorizationDialogByProtocol(foundChannelByIdFromUrl);
      setOpenPendingChannelDialog(false);
    }
  }, [
    foundChannelByIdFromUrl,
    openAuthorizationDialogByProtocol,
    setOpenPendingChannelDialog,
    step,
  ]);
}
